//Language files in ISO 639-1 standard. ex: en-us.json, es-cl.json, es-es.json.

//.json structure:
// {
//   "_STRINGS" : {
//     "KEY": "STRING"
//   },
//   "_PARENT" : "<Default language to not overdeclare repeated strings across languages>"
// }
//

import { derived } from 'svelte/store';
import { dictionary, locale, getLocaleFromNavigator, _ } from 'svelte-i18n';
import CommonDataManager from '../controllers/CommonDataManager.js';

let currentLocale = null;
const isLocaleLoaded = derived(locale, $locale => typeof $locale === 'string');
const commonData = CommonDataManager.getInstance();


async function _loadJSON(path, callback) {
      const response = await fetch(path);
      const json = await response.json();

      callback(json);
}

let _countryToLocale = {
  US: "en-us", MX: "es-mx", HN: "es-hn", CL: "es-cl"
};

let _fallback = {
  en: "en-us",
  es: "es-mx",
  _default: "en-us"
};

async function _fetchLanguageDictionary(language){
  return new Promise(resolve => {
    _loadJSON("/strings/"+language+".json?v=1.1.1", (jsonObj) => {
      resolve(jsonObj);
    });
  });
}

function _composeLanguageDictionary(hierarchy){
  let finalDictionary = hierarchy[0];

  for (var i = 1; i < hierarchy.length; i++) {
    const dictionaryToAdd = hierarchy[i];
    Object.keys(dictionaryToAdd).forEach((string, i) => {
      finalDictionary[string] = dictionaryToAdd[string];
    });
  }

  return finalDictionary;
}

//Load language and all nested parents
async function _loadLanguage(language, children = []){
    console.log("GETTING FILE")
    const dict = await _fetchLanguageDictionary(language);
    console.log("GOT FILE")
    if (dict._PARENT) {
      return _loadLanguage(dict._PARENT, [dict._STRINGS, ...children]);
    }
    else {
      return new Promise(resolve => {
        resolve(_composeLanguageDictionary([dict._STRINGS, ...children]));
      });
    }
}

//PUBLIC
async function setLocale(language){
  _loadLanguage(language)
  .then((_dictionary) => {
    if (_dictionary) {
      dictionary.set({ [language]: _dictionary });
      locale.set(language);
      currentLocale = language;
      commonData.setLoadedLocale(language);
    }
  })
  .catch((err) => {
    console.error(err);
  });
}

function localeForCountry(country){
  if (Object.keys(_countryToLocale).includes(country)) {
    return _countryToLocale[country];
  }
  else {
    return localeForDevice();
  }
}

function localeForDevice(){
  let deviceLocale = getLocaleFromNavigator();
  if (Object.values(_countryToLocale).includes(deviceLocale)) {
    return deviceLocale.toLowerCase();
  }
  else {
    if (Object.keys(_fallback).includes(deviceLocale.substring(0,2))) {
      return _fallback[deviceLocale.substring(0,2)];
    }
    else {
      return _fallback._default;
    }
  }
}

export { _, setLocale, localeForCountry, localeForDevice, isLocaleLoaded, currentLocale };
